import { render, staticRenderFns } from "./conventionmodal.vue?vue&type=template&id=92f8caca&scoped=true"
import script from "./conventionmodal.vue?vue&type=script&lang=js"
export * from "./conventionmodal.vue?vue&type=script&lang=js"
import style0 from "./conventionmodal.vue?vue&type=style&index=0&id=92f8caca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f8caca",
  null
  
)

export default component.exports